import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {MethodsService} from 'src/app/services/methods.service';
import {InteractionsService} from 'src/app/services/interactions.service';

@Component({
    selector: 'app-timeline',
    templateUrl: './timeline.component.html',
    styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit, OnDestroy {

    @Input('interactionId') interactionId;
    public interaction;
    private interactionsSubscriber;
    public language;
    constructor(
        private methods: MethodsService,
        private interactionsService: InteractionsService
    ) {
      this.language = localStorage.getItem('l')
    }

    ngOnInit(): void {
        this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
            this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
            this.methods.get('assets/data/' +this.language +'/' + this.interaction.content.configId + '.config.json')
                .subscribe(config => {
                    this.interaction.timeline = config;
                    console.log('interaction', this.interaction);
                });
          this.interactionsService.setCompleted(this.interaction);
        });

    }
ngOnDestroy(): void {
        this.interactionsSubscriber.unsubscribe();
}
}
